import React from 'react';

const RangePrice = () => {
    return (
        <div className="price-slider position-relative">
            <div className="price-text position-absolute">
                <div className="show-min-price persian-number min-price-slider"></div>
                <div className="show-max-price persian-number max-price-slider"></div>
            </div>
            <div className="middle">
                <div className="multi-range-slider">
                    <input className="change-select input-price-slide-left" type="range" min="0" max="100"/>
                    <input className="change-select input-price-slide-right" type="range" min="0" max="100"/>
                    <div className="slider">
                        <div className="track"></div>
                        <div className="range"></div>
                        <div className="thumb left"></div>
                        <div className="thumb right"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RangePrice;
